import type { BoxProps } from './Box.typed';
import * as Styled from './Box.styled';

export const Box = (props: BoxProps) => {
  const { children, ...rest } = props;

  return <Styled.Box {...rest}>{children}</Styled.Box>;
};

export default Box;
